import { generateBFFUrl, IR_WORK_ORDERS, SERVICE_REQUEST_HISTORY } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { ASSET_ID_QUERY_PARAM } from '@/configs/serviceConstants';
import { WorkOrder } from '@/types/asset';

export const serviceRequestHistory = (assetId?: string, serverCookie?: any, params?: any) => {
  return axiosInstance
    .get(generateBFFUrl(SERVICE_REQUEST_HISTORY), {
      headers: generateHttpHeaders(serverCookie),
      params: {
        [ASSET_ID_QUERY_PARAM]: assetId,
        ...(params ?? {}),
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error: any) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
};

export const getIRWorkOrders = async (serverCookie?: string): Promise<any> => {
  try {
    return await axiosInstance.get(generateBFFUrl(IR_WORK_ORDERS), {
      headers: generateHttpHeaders(serverCookie),
    });
  } catch (error: any) {
    console.error(error, 'getIRWorkOrders');
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
